import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=78c0d5fc&scoped=true&"
import script from "./thumbnail.vue?vue&type=script&lang=js&"
export * from "./thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./thumbnail.vue?vue&type=style&index=0&id=78c0d5fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0d5fc",
  null
  
)

export default component.exports